import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { usePermissions } from '~/composables/usePermissions'
import { ROUTE_NAMES } from '~/constants/routes'

// eslint-disable-next-line consistent-return
export default defineNuxtRouteMiddleware(async (to) => {
  const { hasRouteAccess } = usePermissions()

  if (!hasRouteAccess(to)) {
    return navigateTo({
      name: ROUTE_NAMES.NO_ACCESS,
    })
  }
})
